<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Header -->
							<div class="page_header">Search Training Effectiveness Records</div>
				
							<div class="page_main">
								<el-form :model="query" label-position="top" class="search-form">
									<div class="form-grid">
										<!-- Left -->
										<div class="form-col">
											<el-form-item label="Training Item Type">
												<el-select
													v-model="query.leixing"
													class="full-width"
													placeholder="Please Select"
													clearable
												>
													<el-option label="General Training Item" :value="1" />
													<el-option label="Document" :value="2" />
												</el-select>
											</el-form-item>
				
											<el-form-item label="Training Item ID">
												<el-input
													v-model="query.item_name"
													placeholder="Please Enter"
													clearable
												/>
											</el-form-item>
				
											<el-form-item label="Status">
												<el-select
													v-model="query.status"
													class="full-width"
													placeholder="Please Select"
													clearable
												>
													<el-option label="In Progress" :value="1" />
													<el-option label="Completed" :value="2" />
													<el-option label="Withdrawn" :value="9" />
												</el-select>
											</el-form-item>
				
											<el-form-item label="Training Effective?">
												<el-select
													v-model="query.training_effictive"
													class="full-width"
													placeholder="Please Select"
													clearable
												>
													<el-option label="/" :value="0" />
													<el-option label="Yes" :value="1" />
													<el-option label="No" :value="2" />
												</el-select>
											</el-form-item>
										</div>
				
										<!-- Right -->
										<div class="form-col">
											<el-form-item label="Created Date">
												<el-date-picker
													v-model="time"
													type="datetimerange"
													@change="getTime"
													range-separator="To"
													start-placeholder="Start Date"
													end-placeholder="End Date"
													class="full-width"
													:default-time="['00:00:00', '23:59:59']"
												>
												</el-date-picker>
											</el-form-item>
				
											<el-form-item label="Record Closed Date">
												<el-date-picker
													v-model="time1"
													type="datetimerange"
													@change="getTime1"
													range-separator="To"
													start-placeholder="Start Date"
													end-placeholder="End Date"
													class="full-width"
													:default-time="['00:00:00', '23:59:59']"
												>
												</el-date-picker>
											</el-form-item>
				
											<el-form-item label="Evaluation Guidelines">
												<el-input
													v-model="query.effectiveness_evaluation_guidelines"
													placeholder="Please Enter"
													clearable
												/>
											</el-form-item>
				
											<el-form-item label="Description">
												<el-input
													v-model="query.description"
													placeholder="Please Enter"
													clearable
												/>
											</el-form-item>
										</div>
									</div>
				
									<div class="search-btn-wrap">
										<el-button type="primary" @click="handleSearch">
											Search
										</el-button>
									</div>
								</el-form>
				
								<!-- Table -->
								<div class="file-panel">
									<div class="panel-header">
										<div></div>
				
										<el-input
											v-model="keyword"
											placeholder="Search"
											clearable
											class="search-input"
										>
											<i slot="prefix" class="el-input__icon el-icon-search"></i>
										</el-input>
									</div>
				
									<el-table
										:data="trainTableData"
										border
										class="file-table"
										header-cell-class-name="table-header-cell"
									>
										<el-table-column
											label="Training Item Type"
											min-width="200"
											sortable
											show-overflow-tooltip
										>
											<template #default="scope">
												<div v-if="scope.row.leixing == 1">
													General Training Item
												</div>
												<div v-if="scope.row.leixing == 2">
													Document
												</div>
											</template>
										</el-table-column>
				
										<el-table-column
											prop="item_name"
											label="Training Item ID"
											min-width="400"
											sortable
											show-overflow-tooltip
										/>
				
										<el-table-column
											label="Status"
											min-width="110"
											sortable
											align="center"
										>
											<template #default="scope">
												<div v-if="scope.row.status == 1">
													In Progress
												</div>
												<div v-if="scope.row.status == 2">
													Completed
												</div>
												<div v-if="scope.row.status == 9">
													Withdrawn
												</div>
											</template>
										</el-table-column>
				
										<el-table-column
											label="Evaluation Guidelines"
											min-width="210"
											sortable
											show-overflow-tooltip
										>
											<template #default="scope">
												<div>
													{{ scope.row.effectiveness_evaluation_guidelines || "/" }}
												</div>
											</template>
										</el-table-column>
				
										<el-table-column
											label="Training Effective?"
											min-width="180"
											sortable
											align="center"
										>
											<template #default="scope">
												<div v-if="scope.row.training_effective == 0">/</div>
												<div v-if="scope.row.training_effective == 1">Yes</div>
												<div v-if="scope.row.training_effective == 2">No</div>
											</template>
										</el-table-column>
				
										<el-table-column
											label="Description"
											min-width="150"
											sortable
											show-overflow-tooltip
										>
											<template #default="scope">
												<div>{{ scope.row.description || "/" }}</div>
											</template>
										</el-table-column>
				
										<el-table-column
											label="Record Closed Date"
											min-width="210"
											sortable
											align="center"
										>
											<template #default="scope">
												<div>{{ scope.row.completed_time || "/" }}</div>
											</template>
										</el-table-column>
				
										<el-table-column
											label="Action"
											width="80"
											align="center"
											fixed="right"
										>
											<template slot-scope="scope">
												<el-link
													type="primary"
													size="mini"
													@click="handleInfo(scope.row)"
												>
													Details
												</el-link>
											</template>
										</el-table-column>
									</el-table>
				
									<div class="pagination">
										<el-pagination
											@size-change="handleSizeChange"
											@current-change="handlePageChange"
											:current-page="query.page"
											:page-sizes="[5, 10, 20, 50]"
											:page-size="query.page_size"
											layout="total, sizes, prev, pager, next"
											:total="pageTotal"
										>
										</el-pagination>
									</div>
								</div>
								<!-- Table -->
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!-- loading -->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
	</div>
</template>

<script>
	import headers from "@/component/header.vue";
	import slider from "@/component/slider.vue";
	import {
		trainSuperviseList
	} from "@/api/trainManage/trainEffective/index";
	import moment from "moment";
	moment.locale("zh-cn");
	export default {
		components: {
			headers,
			slider,
		},
		data() {
			return {
				isLoading: true,
				keyword: "",
				query: {
					leixing: "",
					item_name: "",
					status: "",
					training_effictive: "",
					date_line1: "",
					date_line2: "",
					completed_time1: "",
					completed_time2: "",
					effectiveness_evaluation_guidelines: "",
					description: "",
					page: 1,
					page_size: 10,
				},
				time: "",
				time1: "",
				tableData: [],
				pageTotal: 0,
			};
		},
		created() {
			let that = this;
		},
		mounted() {
			let that = this;
			that.isLoading = false;
			that.getTableData();
		},
		computed: {
			trainTableData() {
				return this.filterTableData(this.tableData, this.keyword);
			},
		},
		methods: {
			filterTableData(source, keyword) {
				if (!keyword || !keyword.trim()) return source;
				const lowerKeyword = keyword.toLowerCase().trim();
				return source.filter((item) => {
					const text = this.flattenValues(item).toLowerCase();
					return text.includes(lowerKeyword);
				});
			},
			flattenValues(data) {
				if (data === null || data === undefined) return "";
				if (Array.isArray(data)) {
					return data.map((item) => this.flattenValues(item)).join(" ");
				}
				if (typeof data === "object") {
					return Object.values(data)
						.map((val) => this.flattenValues(val))
						.join(" ");
				}
				return String(data);
			},
			getTableData() {
				let that = this;
				that.tableLoading = true;
				trainSuperviseList(that.query).then((res) => {
					that.tableLoading = false;
					if (res.code == 200) {
						that.pageTotal = res.data.total;
						that.tableData = res.data.data;
					}
				});
			},
			//时间格式化
			dateFormat: function(row, column) {
				let that = this;
				var date = row[column.property];
				if (date == undefined || date == 0) {
					return "/";
				}
				return moment(date * 1000).format("YYYY-MM-DD");
			},
			//时间选择变化
			getTime(date) {
				let that = this;
				if (date) {
					that.query.date_line1 = moment(date[0]).format("YYYY-MM-DD HH:mm:ss");
					that.query.date_line2 = moment(date[1]).format("YYYY-MM-DD HH:mm:ss");
				} else {
					that.query.date_line1 = "";
					that.query.date_line2 = "";
				}
			},
			getTime1(date) {
				let that = this;
				if (date) {
					that.query.completed_time1 = moment(date[0]).format(
						"YYYY-MM-DD HH:mm:ss"
					);
					that.query.completed_time2 = moment(date[1]).format(
						"YYYY-MM-DD HH:mm:ss"
					);
				} else {
					that.query.completed_time1 = "";
					that.query.completed_time2 = "";
				}
			},
			handleSearch() {
				let that = this;
				that.query.page = 1;
				that.getTableData();
			},
			//清空搜索项
			clearSearch() {
				let that = this;
				that.query = {
					leixing: "",
					item_name: "",
					status: "",
					training_effictive: "",
					date_line1: "",
					date_line2: "",
					completed_time1: "",
					completed_time2: "",
					effectiveness_evaluation_guidelines: "",
					description: "",
					page: 1,
					page_size: 10,
				};
				that.time = null;
				that.time1 = null;
				that.getTableData();
			},
			//条数选择
			handleSizeChange(value) {
				let that = this;
				that.query.page_size = value;
				that.getTableData();
			},
			//页数跳转
			handlePageChange(value) {
				let that = this;
				that.query.page = value;
				that.getTableData();
			},
			handleInfo(value) {
				let that = this;
				const routeData = that.$router.resolve({
					path: '/TrainControl/effective-detail',
					query: {
						id: value.id
					}
				});
				window.open(routeData.href, "_blank");
			},
			//跳转页面
			goUrl(url) {
				let that = this;
				that.$router.push(url);
			},
		},
	};
</script>

<style lang="less" scoped>
	//主要内容
	.main_main {
		.page_main {
			padding: 18px 20px;

			.btn_el {
				margin: 10px 0 20px 0;

				.tips {
					padding: 6px 8px;
					background-color: #ffb1001a;
					border-radius: 6px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}

		//页头
		.page_header {
			padding: 0 20px;
			height: 60px;
			line-height: 60px;
			background-color: #d8e4f0;
			font-size: 24px;
			font-weight: bold;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
		}
	}
</style>
<style scoped>
	.main_box {
		height: calc(100vh - 60px);
		overflow-y: auto;
	}

	.main_box .main_main {
		position: relative;
		min-height: calc(100% - 0px);
		max-height: auto;
		background-color: #fafafa;
	}

	.el-header,
	.el-main {
		padding: 0;
	}

	.form-grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-column-gap: 24px;
		align-items: start;
	}

	.form-grid .el-form-item {
		margin-bottom: 0;
	}

	.full-width {
		width: 100%;
	}

	.input-btn-group {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.input-btn-group .el-input {
		flex: 1;
	}

	.search-btn-wrap {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 20px 0 16px;
	}

	.file-panel {
		background: #fff;
		border: 1px solid #dcdfe6;
		margin-top: 40px;
	}

	.panel-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 16px;
	}

	.search-input {
		width: 220px;
	}

	.file-table {
		width: 100%;
		margin-top: 8px;
	}

	.pagination {
		margin: 10px 0;
		text-align: right;
	}

	::v-deep .el-form-item__label {
		font-size: 16px;
		color: #222;
		font-weight: 700;
		padding-bottom: 8px;
		position: relative;
	}

	::v-deep .el-input__inner,
	::v-deep .el-textarea__inner {
		border-radius: 4px;
	}

	@media (max-width: 1200px) {
		.form-grid {
			grid-template-columns: 1fr;
		}
	}

	::v-deep .el-button {
		border-radius: 6px;
	}

	::v-deep .btn span {
		text-decoration: underline;
	}

	::v-deep .form-grid .el-form-item__label {
		padding-bottom: 0;
	}
</style>